import type { FeatureGroup } from '../../../../types';
import { ASSETS_FEATURE_GROUP } from '../group';

export const ASSETS_DESCRIPTION_FEATURE_GROUP: FeatureGroup = {
  guid: 'd4e6f201-9a3b-4c57-b183-6c7d8e2fff00',
  name: 'assets:description',
  description: 'Description asset features — SEO metadata and analytics code settings',
  product: 'account',
  parentGuid: ASSETS_FEATURE_GROUP.guid,
};
